var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickGuideWithoutBgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.53664,
    y: 0.930063,
    width: 12.5323,
    height: 13.1503,
    rx: 2.25,
    transform: "matrix(0.962557 0.271078 -0.247038 0.969006 5.74302 0.883355)",
    stroke: "#2D344B",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8496_12123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 15,
    rx: 3,
    fill: "#C0D4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 12.5,
    height: 13.5,
    rx: 2.25,
    stroke: "#2D344B",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12967 10.7709H7.97967C7.73491 10.7709 7.5584 10.559 7.5584 10.3251C7.5584 9.92616 7.6102 9.57434 7.71738 9.27342C7.79709 9.04389 7.9249 8.81677 8.09633 8.59145L8.09683 8.59079C8.22488 8.42443 8.44816 8.1886 8.76203 7.8871L8.86594 7.99528M8.12967 10.7709L5.90415 6.16255C5.82161 6.46709 6.01185 6.77876 6.30073 6.81608L6.2814 6.96483C6.28144 6.96483 6.28148 6.96484 6.28152 6.96484C6.59237 7.00518 6.87132 6.79501 6.95292 6.49056L6.95294 6.49048C7.04206 6.15719 7.1734 5.9119 7.3384 5.74353C7.56649 5.51088 7.84884 5.39399 8.19557 5.39399C8.55293 5.39399 8.85018 5.52187 9.09612 5.78215C9.34539 6.04594 9.46683 6.34592 9.46683 6.68932C9.46683 6.87838 9.42573 7.04953 9.34367 7.20552C9.26156 7.36157 9.07356 7.58731 8.76193 7.8872L8.86594 7.99528M8.12967 10.7709V10.7704M8.12967 10.7709V10.7704M8.86594 7.99528C9.17898 7.69403 9.3823 7.45424 9.47642 7.27536C9.57053 7.09647 9.61683 6.90113 9.61683 6.68932C9.61683 6.30577 9.47944 5.9694 9.20515 5.67913C8.93086 5.38886 8.59417 5.24399 8.19557 5.24399C7.81057 5.24399 7.48897 5.37569 7.23129 5.63852L7.82967 10.5717C7.75654 10.5188 7.7084 10.4282 7.7084 10.3251C7.7084 9.9383 7.75873 9.60413 7.85888 9.32318C7.93236 9.11138 8.05164 8.89793 8.2157 8.68228C8.33649 8.52534 8.5529 8.29598 8.86594 7.99528ZM8.12967 10.7704H8.31837C8.55421 10.7704 8.73012 10.5722 8.74098 10.3455L8.12967 10.7704ZM8.8032 9.80256L8.80318 9.80261C8.77454 9.91826 8.75292 10.0976 8.74098 10.3455L8.8032 9.80256ZM8.8032 9.80256C8.84276 9.64257 8.90313 9.50375 8.98294 9.38482C9.06363 9.26459 9.24557 9.06435 9.54039 8.77917L8.8032 9.80256ZM8.17293 11.3253C7.79379 11.3253 7.50807 11.6562 7.50807 12.0366C7.50807 12.417 7.79379 12.7479 8.17293 12.7479C8.55206 12.7479 8.83778 12.417 8.83778 12.0366C8.83778 11.6562 8.55206 11.3253 8.17293 11.3253Z",
    fill: "#2D344B",
    stroke: "#2D344B",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8496_12123",
    x: 0,
    y: 0,
    width: 16,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8496_12123"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.752941 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8496_12123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8496_12123",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickGuideWithoutBgIcon);
export default __webpack_public_path__ + "static/media/quick-guide-without-bg-icon.1e04cf9b5f6fd125d5dc3f1fbf971971.svg";
export { ForwardRef as ReactComponent };